import { createApp } from "vue";
import App from "./App.vue";
import { startApp } from "./app";

// Mount the Vue app first, then start the configurator (it expects the page components to exist)
createApp(App).mount("#app");
startApp();
